import React, { Component } from 'react'
import _ from 'lodash'

class ConsultaChoferInfo extends Component {
  constructor (props) {
    super(props)
    this.defaultFields = [
      'numero', 'camion', 'acoplado', 'cereal', 'fechaCupo', 'turno', 'cpeSucursal'
    ]
    this.strongFields = ['turno']
    this.renderField = this.renderField.bind(this)
    this.renderFields = this.renderFields.bind(this)
  }

  renderField ({ field, value, key }) {
    return (
      <div key={key} className={`info-cpa-column`}>
        <div className='info-cpa-label-consulta-chofer'>{_.startCase(field)}</div>
        <div className={`info-cpa-value`}>
          {value}
        </div>
      </div>
    )
  }

  renderFields (cpaDatos, fields = null) {
    fields = fields || this.defaultFields
    return (
      <div className='info-cpa-row info-cpa-row-consulta-chofer'>
        {
          fields.filter(field => cpaDatos[field])
            .map((field, key) => {
              return this.renderField({ field, value: cpaDatos[field], key })
            })
        }
      </div>
    )
  }

  render () {
    const {
      cpaDatos
    } = this.props

    return (
      <div className='show-cpa-info'>
        {this.renderFields(cpaDatos)}
      </div>
    )
  }
}

export default ConsultaChoferInfo
